import { createContext, ReactNode, useMemo } from 'react';
import { useNullableContext } from 'shared/hooks/useNullableContext';
import { UpdateParams, useLocationParams } from 'shared/routing/LocationParams';

import {
  ReportsDeliveryTrendParamsDTO,
  reportsDeliveryTrendParamsSchema,
} from './ReportsDTO';

interface ReportsDeliveryTrendContext {
  params: ReportsDeliveryTrendParamsDTO;
  setParams: UpdateParams<ReportsDeliveryTrendParamsDTO>;
}

const Context = createContext<null | ReportsDeliveryTrendContext>(null);

export function useReportsDeliveryTrendContext() {
  return useNullableContext('ReportsDeliveryTrend', Context);
}

interface Props {
  children?: ReactNode;
}

export function ReportsDeliveryTrendContextProvider({ children }: Props) {
  const [params, setParams] = useLocationParams<ReportsDeliveryTrendParamsDTO>({
    zodSchema: reportsDeliveryTrendParamsSchema,
    persistName: 'ReportsDeliveryTrend',
  });

  const ctx = useMemo<ReportsDeliveryTrendContext>(
    () => ({ params, setParams }),
    [params, setParams],
  );

  return <Context.Provider value={ctx}>{children}</Context.Provider>;
}
